import Select from './select.js';
export default Select;
